import React from 'react'
import { useMonthlySummaryNotifications } from './useMonthlySummaryNotifications'

type Props = {
  uid: string
  children: React.ReactNode
}

export const MonthlySummaryNotificationProvider = ({ uid, children }: Props) => {
  useMonthlySummaryNotifications(uid)

  return <>{children}</>
}
